export enum conversionLabels {
  NON_HYPERLOCAL_PLACE_ORDER_ENQUIRY = 'xDDdCL3tgq8YELX_77kC',
  ADD_TO_CART = 'xMNoCLW_hK4YELX_77kC',
  BUY_NOW = 'hQ7oCIDRgq8YELX_77kC',
  ORDER_CREATED = 'pmMSCO6_-K4YELX_77kC',
}
